import cx from 'classnames'
import type { ReactNode } from 'react'
type Props = {
  children: ReactNode
  isNotRelevant?: boolean
  shouldSkipLayout?: boolean
}

export const DetailsLayout = ({
  children,
  isNotRelevant,
  shouldSkipLayout,
}: Props) =>
  shouldSkipLayout ? (
    children
  ) : (
    <div
      className={cx(
        'group grid max-h-full w-full grid-cols-[auto_minmax(0,1fr)] items-start gap-6 overflow-y-auto overflow-x-hidden p-2',
        isNotRelevant ? 'is-not-relevant' : undefined,
      )}
    >
      {children}
    </div>
  )
